export default __webpack_public_path__ + "static/media/shield.73d601c5.webp";